// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5cc022a5","455":"a66618a2","977":"c3815bf0"}[chunkId] + ".chunk.js";
};